import React from "react";
import Skeleton, {SkeletonTheme} from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

export const NavPanelSkeleton = () => {
    return (
        <SkeletonTheme baseColor={'#121620'}
                       highlightColor={'#23262D'}
                       duration={1}>
            <div className={'app-nav-panel'}>
                <div className="app-nav-header">
                    <div className="flex-centered">
                        <Skeleton circle width={40} height={40}/>
                    </div>
                </div>

                <div className="app-nav-welcome">
                    <span className="profile-name">
                        <Skeleton width={160} height={22} borderRadius={8}/>
                    </span>
                </div>

                <div style={{marginBottom: 20, marginTop: 15}}>
                    <Skeleton height={40} borderRadius={15} style={{marginLeft: 80}} width={100}/>
                </div>

                <div className={'app-nav-menu'}>
                    <ul className={'app-nav-ul'}>
                        {Array.from({length: 4}).map((_, index) => (
                            <li key={index} style={{marginBottom: 12}} className={'app-nav-li'}>
                                <Skeleton width={'85%'} height={40} borderRadius={12} style={{marginLeft: 20}}/>
                            </li>
                        ))}
                    </ul>
                </div>

                <div className={'app-nav-settings'}>
                    <ul className={'app-nav-ul'}>
                        <li>
                            <Skeleton width={'85%'} height={100} borderRadius={12} style={{marginLeft: 20}}/>
                        </li>
                    </ul>
                </div>

                <div className={'app-nav-footer'}>
                    <span>Powered by HungryScan &copy;</span>
                </div>
            </div>
        </SkeletonTheme>
    );
};